import { Typography, Stack, Box } from '@mui/material';


export default function ImportDataHeader() {
    return (
        <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
            sx={{
                backgroundColor: '#20b2aa', // corrected 'bgColor' to 'backgroundColor'
                height: 40,
                mb: 2,
                borderRadius: '8px',
                marginBottom: '0.2rem'
            }}
        >
            <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' spacing={1}>
                <Typography
                    variant='body1'
                    sx={{ fontSize: '1rem', lineHeight: '0.8rem', color: '#fff' }}
                    style={{ marginLeft: '10px' }}
                >
                    Loyalty Set Opening Point
                </Typography>
            </Stack>
            <Box flexGrow={1} />
        </Stack>
    );
}